import { getConfiguredLabel } from "../../common/commonHelper";
import { DocumentsPage, HomePage, goToDocs, saveToasterMessage } from "../../common/labelConstants";
import { AppToast } from "../../lib/toast";
import { saveDocuments } from "../../store/documents/documentSlice";

export function createFileObject(file){
    if(!file || !file.file) return null
    return {
        serverFileId: file.file.serverId,
        originalFileName: file.file.filenameWithoutExtension,
        fileExt: file.file.fileExtension,
        fileSize: file.file.fileSize,
        updatedFileName: file.fileName,
        metadata: file.metadata,
        fileAccessibility : file.fileAccessibility,
        roles: file.role
    }
}

export function updateDocumentUpload(parentData, newDocData, dispatch){
    let updatedDoc = {...newDocData.updateDoc, metadata:newDocData.metadata, fileAccessibility:newDocData.fileAccessibility, roles:newDocData.role, updatedFileName:newDocData.fileName};
    if(parentData.parentDocId){
        updatedDoc={...updatedDoc,parentDocId:parentData.parentDocId}
    }else{
        updatedDoc={...updatedDoc,parentDocId:parentData._id}
    }

    dispatch(saveDocuments([updatedDoc])).then((res)=>{
        if(res.payload.status === 200){
            AppToast.Toast.success({ title: getConfiguredLabel(DocumentsPage,saveToasterMessage), message: getConfiguredLabel(HomePage,goToDocs) })
        }
    })
}